import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// Shown instead of the check-in form once every sample on the order has been
// covered by a prior submission -- there's nothing left to select, so the
// user shouldn't be able to submit another check-in sheet.
export default function AllSamplesSubmitted({ orderId, checkInSheetCount, totalSampleCount, onBack }) {
  return (
    <Paper elevation={1} sx={{ p: 4, textAlign: "center" }}>
      <Box sx={{ color: "success.main", mb: 1 }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 48 }} />
      </Box>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        All samples already checked in
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        All {totalSampleCount} sample{totalSampleCount === 1 ? "" : "s"} on order {orderId} have
        already been submitted across {checkInSheetCount} check-in sheet
        {checkInSheetCount === 1 ? "" : "s"}. There's nothing left to check in.
      </Typography>
      <Button variant="contained" onClick={onBack}>
        Back
      </Button>
    </Paper>
  );
}
